export const LARGE = 'large'
export const SMALL = 'small'

export const handleChevronStyles = (direction, images, initial, condition) => {
    if (direction === 'vertical') {
        if (images >= 4) {
            if (initial === condition) {
                return {color: 'background.grey', cursor: 'default'}
            } else return {color: 'background.dark', cursor: 'pointer'}
        } else {
            return {color: 'background.grey', cursor: 'default'}
        }
    }

    return {color: 'foreground.neutral.inverse', cursor: 'pointer'}
}
